import PropTypes from 'prop-types';

import { AlertBox } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { howToBookItems } from '../../utils/howToBookItems';

import { HowToBookSection } from './HowToBookSection';
import './HowToBook.scss';
import CheckPolicyIcon from './icons/CheckPolicyIcon';
import RentalConditionsGuaranteeIcon from './icons/RentalConditionsGuaranteeIcon';

const renderPointWithSubpoints = point => {
  if (!point.subpointKeys || point.subpointKeys.length === 0) {
    return null;
  }

  return (
    <ul>
      {point.subpointKeys.map(sub => (
        <li key={sub}>{trans(sub)}</li>
      ))}
    </ul>
  );
};

const HowToBook = ({ hasVetting = false }) => {
  return (
    <div className="how-to-book-redesign">
      <div className="how-to-book-redesign__wrapper">
        {howToBookItems.map(
          ({ id, titleKey, pointKeys, icon, isCollapsed }) => (
            <HowToBookSection
              key={id}
              stepNumber={id}
              Icon={icon}
              isCollapsed={isCollapsed}
              title={trans(titleKey)}
              renderContent={() => {
                return (
                  <ul>
                    {pointKeys.map(point => {
                      return (
                        <li key={point.textKey}>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: trans(point.textKey)
                            }}
                          />
                          {renderPointWithSubpoints(point)}
                        </li>
                      );
                    })}
                  </ul>
                );
              }}
            />
          )
        )}
      </div>
      <AlertBox
        className="how-to-book-redesign__alert-box"
        titleClassName="how-to-book-redesign__alert-box__title"
        iconClassName="how-to-book-redesign__alert-box__icon"
        icon={<CheckPolicyIcon />}
        iconPosition="top"
        title={trans('listing.how-to-book.24h-check.policy.title')}
        message={
          <div className="how-to-book-redesign__alert-box__message">
            {trans('listing.how-to-book.24h-check.policy.message')}
          </div>
        }
        roundedCorners
        theme="white"
      />
      {hasVetting && (
        <AlertBox
          className="how-to-book-redesign__alert-box"
          titleClassName="how-to-book-redesign__alert-box__title"
          iconClassName="how-to-book-redesign__alert-box__icon"
          icon={<RentalConditionsGuaranteeIcon />}
          iconPosition="top"
          title={trans('listing.how-to-book.early-checkout.title')}
          message={
            <div className="how-to-book-redesign__alert-box__message">
              {trans('listing.how-to-book.early-checkout.message')}
            </div>
          }
          roundedCorners
          theme="white"
        />
      )}
    </div>
  );
};

HowToBook.propTypes = {
  hasVetting: PropTypes.bool
};

export default HowToBook;
